<template>
  <!-- <video crossorigin playsinline /> -->
  <div
    style="height: 100%; background-color: black; padding: 0;"
  >
    <b-embed
      v-if="drop.video && drop.video.file !== '' && countdownComplete"
      id="video"
      type="video"
      aspect="4by3"
      autoplay
      controls
      allowfullscreen
      @click="togglePlayPause"
    >
      <source :src="drop.video.file" type="video/mp4">
    </b-embed>

    <iframe
      v-if="drop.rewards[0] && drop.rewards[0].iframe"

      :src="drop.rewards[0].iframe + '?display_name='+drop.user.name+'&drop='+drop._id+'&launch_date='+drop.launchDate+'&username='+drop.user.username"
      style="position: relative; height: 100vh; width:100%; border:none"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: { },
  mixins: [],
  computed: {
    ...mapState(['drop'])
  },
  data () {
    return {
      countdownComplete: false
    }
  },
  mounted () {
    debugger
    if (this.drop.launchDate) {
      const launchDate = new Date(this.drop.launchDate)
      const now = new Date().getTime()
      const distance = launchDate - now
      if (distance < 0) {
        this.countdownComplete = true
      }
    }

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('debug') === 'true') {
      this.countdownComplete = true
    }
  },
  methods: {
    togglePlayPause () {
      console.log('toggle play pause')
      // const videoElement = document.getElementById('video')
      // if (videoElement.paused) {
      //   videoElement.play()
      // } else {
      //   videoElement.pause()
      // }
    }
  }
}
</script>
